import { render, staticRenderFns } from "./DetailV2.vue?vue&type=template&id=39f2ccec"
import script from "./DetailV2.vue?vue&type=script&lang=ts"
export * from "./DetailV2.vue?vue&type=script&lang=ts"
import style0 from "./DetailV2.vue?vue&type=style&index=0&id=39f2ccec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports